<template>
  <div class="container-fluid mt-3">
    <div class="update-crew">
      <div class="row p-3">
        <div class="col col-sm-10">
          <h3>Crew Details</h3>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col col-md-12 justify-content-center">
              <div class="text-center">
                <form @submit="uploadCrewImg">
                  <img
                    src="../../assets/logo.png"
                    alt="..."
                    class="img-thumbnail"
                  >
                  <button
                    type="submit"
                    class="btn btn-secondary btn-sm"
                  >
                    upload
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        <form @submit="editCrew">
          <div class="card-body">
            <div class="row mt-3">
              <div class="col col-md-6">
                <div class="form-group">
                  <label
                    for="lastname"
                    class="font-weight-bold"
                  >Last Name</label>

                  <input
                    type="text"
                    class="form-control form-control-sm"
                    id="lastname"
                    placeholder="last name"
                    :readonly="!editableCrew"
                    v-model="crew.detail.last_name"
                  >
                  <span
                    class="error-tag"
                    v-if="errorUpdateCrew.last_name!== null"
                  >
                    <small><strong>*{{ errorUpdateCrew.last_name }}</strong></small>
                  </span>
                </div>

                <div class="form-group">
                  <label
                    for="firstname"
                    class="font-weight-bold"
                  >First Name</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    id="firstname"
                    placeholder="first name"
                    :readonly="!editableCrew"
                    v-model="crew.detail.first_name"
                  >

                  <span
                    class="error-tag"
                    v-if="errorUpdateCrew.first_name!== null"
                  >
                    <small><strong>*{{ errorUpdateCrew.first_name }}</strong></small>
                  </span>
                </div>

                <div class="form-group">
                  <label
                    for="middleName"
                    class="font-weight-bold"
                  >Middle Name</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    id="middleName"
                    placeholder="middle name"
                    :readonly="!editableCrew"
                    v-model="crew.detail.middle_name"
                  >
                  <span
                    class="error-tag"
                    v-if="errorUpdateCrew.middle_name!== null"
                  >
                    <small><strong>*{{ errorUpdateCrew.middle_name }}</strong></small>
                  </span>
                </div>

                <div class="form-group">
                  <label
                    for="birthdate"
                    class="font-weight-bold"
                  >Birthdate</label>
                  <input
                    type="date"
                    class="form-control form-control-sm"
                    id="birthdate"
                    placeholder="birthdate"
                    :readonly="!editableCrew"
                    v-model="crew.detail.birthdate"
                  >
                  <span
                    class="error-tag"
                    v-if="errorUpdateCrew.birthdate!== null"
                  >
                    <small><strong>*{{ errorUpdateCrew.birthdate }}</strong></small>
                  </span>
                </div>

                <div class="form-group">
                  <label
                    for="rank"
                    class="font-weight-bold"
                  >Rank</label>

                  <select
                    id="rank"
                    class="form-control form-control-sm"
                    v-model="crew.detail.rank_id"
                    :disabled="!editableCrew"
                  >
                    <option
                      selected
                      disabled
                    >
                      Choose Ranks...
                    </option>
                    <option
                      class="font-weight-bold"
                      v-for="rank in ranks"
                      :selected="crew.detail.rank_id === rank.id"
                      :value="rank.id"
                      :key="rank.id"
                    >
                      {{ rank.name }}
                    </option>
                  </select>

                  <span
                    class="error-tag"
                    v-if="errorUpdateCrew.rank_id!== null"
                  >
                    <small><strong>*{{ errorUpdateCrew.rank_id }}</strong></small>
                  </span>
                </div>
              </div>

              <div class="col col-md-6">
                <form>
                  <div class="form-group">
                    <label
                      for="crewcode"
                      class="font-weight-bold"
                    >Crewcode</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      id="crewcode"
                      placeholder="crew code"
                      :readonly="!editableCrew"
                      v-model="crew.detail.crewcode"
                    >

                    <span
                      class="error-tag"
                      v-if="errorUpdateCrew.crewcode !== null"
                    >
                      <small><strong>*{{ errorUpdateCrew.crewcode }}</strong></small>
                    </span>
                  </div>

                  <div class="form-group">
                    <label
                      for="email"
                      class="font-weight-bold"
                    >Email</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      id="email"
                      placeholder="Another input"
                      :readonly="!editableCrew"
                      v-model="crew.detail.email"
                    >
                    <span
                      class="error-tag"
                      v-if="errorUpdateCrew.email !== null"
                    >
                      <small><strong>*{{ errorUpdateCrew.email }}</strong></small>
                    </span>
                  </div>

                  <div class="form-group">
                    <label
                      for="contact1"
                      class="font-weight-bold"
                    >Contact #1</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      id="contact1"
                      :readonly="!editableCrew"
                      placeholder="Another input"
                    >
                  </div>

                  <div class="form-group">
                    <label
                      for="contact2"
                      class="font-weight-bold"
                    >Contact #2</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      id="contact2"
                      :readonly="!editableCrew"
                      placeholder="Another input"
                    >
                  </div>

                  <div class="form-group">
                    <label
                      for="address"
                      class="font-weight-bold"
                    >Address</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      id="address"
                      placeholder="Another input"
                      :readonly="!editableCrew"
                      v-model="crew.detail.address"
                    >

                    <span
                      class="error-tag"
                      v-if="errorUpdateCrew.address !== null"
                    >
                      <small><strong>*{{ errorUpdateCrew.address }}</strong></small>
                    </span>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div class="card-footer">
            <button
              type="submit"
              class="btn btn-warning btn-sm"
            >
              <i class="fa fa-edit" />
              {{ editableCrew ? 'SAVE':'EDIT' }}
            </button>
                        &nbsp;&nbsp;

            <button
              type="button"
              class="btn btn-secondary btn-sm"
              v-if="editableCrew"
              @click="cancel"
            >
              <i class="fa fa-ban" />
              CANCEL
            </button>

            <button
              type="button"
              class="btn btn-secondary btn-sm"
              v-else
              @click="goBack"
            >
              <i class="fa fa-undo-alt" />
              GO BACK
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { formMixins } from '../../mixins/formMixins';
    export default {
        mixins: [formMixins],
        props: ['id'],
        name: 'UpdateCrew',
        methods: {
            ...mapActions(['viewCrew', 'setEditableCrew', 'updateCrew','getRanks']),
            async editCrew(e) {
                e.preventDefault();
                if (this.editableCrew) {
                    if (await this.confirmUpdateAlert('Are you sure you want to update this user type.?', 'UPDATE')) {
                        this.updateCrew(this.crew.detail);
                    }
                }
                this.setEditableCrew();
                },

            cancel() {
                if (this.editableCrew) {
                    this.setEditableCrew();
                }
            },

            uploadCrewImg(e){
                e.preventDefault();
                alert('sample trigger for the upload');
            }
        },

        computed: {
            ...mapGetters(['crew', 'editableCrew','ranks','errorUpdateCrew']),
        },

        created() {
            this.viewCrew(this.id);
            this.getRanks();
        },
    };
</script>

<style scoped>
    .error-tag{
        color: red;
    }


</style>
